import { useMutation } from '@tanstack/react-query';
import api from 'services/api/api';

export const permissionsByUserGroups = async id => {
	const url = `/usuario/restricoesByGruposUsuario?${id}`;
	const response = await api.get(url);
	return response.data;
};

export const useGetPermissionsByUsersGroups = () => {
	return useMutation(permissionsByUserGroups, {});
};
